import { Ref } from 'react';

import { TRegistrationFormData } from './registration-form';

export type TRegistrationFormCompleteData = TRegistrationFormData;

export enum RegistrationFormComplete {
  REGISTRATION_FORM = 'registrationForm',
  COMPLETION = 'completion'
}

export type TRegistrationFormState = {
  registrationForm: TRegistrationFormData & { isValid?: boolean }
}

export type TRegistrationFormProps = {
  initialValues: any,
  formRef: Ref<HTMLFormElement>,
  onSubmit: (formData: TRegistrationFormCompleteData) => void;
  onChange: (formName: RegistrationFormComplete.REGISTRATION_FORM, fields: { [key: string]: any }) => void;
  isAcceptDisable?: boolean;
  acceptLabel: string;
  clearLabel: string;
  onAccept?: () => void;
  onClear?: () => void;
  isLoading?: boolean;
  submitResponseData?:any;
}
